import { createSelector } from 'reselect';

const contentMask = (state) => state.contentMask;

export const contentMaskSelector = createSelector(contentMask, (contentMask) => contentMask.show);
